import {Component} from '@angular/core';
import {Observable} from 'rxjs';
import {AppState} from '@store/state/app.state';
import {Store} from '@ngrx/store';
import {deleteNotification} from '@store/actions/global.actions';
import {DynamicDialogConfig} from "primeng/dynamicdialog";

@Component({
    selector: 'core-notification-content',
    standalone: false,
    templateUrl: './notification-content.component.html',
    styleUrls: ['./notification-content.component.scss'],
})
export class NotificationContentComponent {

    types: ('error' | 'info')[] = [];

    notifications$: Observable<{
        id: string,
        notification: string,
        type: 'info' | 'error'
    }[] | null>;


    constructor(private store: Store<AppState>, public config: DynamicDialogConfig) {
        this.notifications$ = this.store.select(state => state.global.notifications);


    }

    ngOnInit(): void {
        if (this.config.data?.types) {
            this.types = this.config.data?.types;
        }
    }

    isIncluded(type: 'info' | 'error'): boolean {
        let isIncluded = false;
        if (this.types.includes(type)) {
            isIncluded = true;
        }
        return isIncluded;
    }


    deleteNotification(id: string) {
        this.store.dispatch(deleteNotification({id}));

    }


}
